import * as pdfjs from 'pdfjs-dist';
import workerUrl from 'pdfjs-dist/build/pdf.worker.min.mjs?url';

// Der pdfjs-Worker wird von Vite gebündelt und als statisches Asset ausgeliefert (kein CDN, damit es
// auf Cloudflare Pages ohne CSP-Ärger lädt).
pdfjs.GlobalWorkerOptions.workerSrc = workerUrl;

/**
 * Liest den Text aus einem digitalen PDF (Textebene) aus — für Händlerbelege beim Ankauf. Zeilen
 * werden über die Y-Position rekonstruiert, damit „Hersteller: X" als eine Zeile ankommt. Für echte
 * Scans (bildbasierte PDFs ohne Textebene) käme später OCR dazu; die getesteten Belege sind digital.
 */
export async function extractPdfText(file: File): Promise<string> {
  const data = new Uint8Array(await file.arrayBuffer());
  const loadingTask = pdfjs.getDocument({ data });
  const doc = await loadingTask.promise;
  const lines: string[] = [];
  try {
    for (let pageNo = 1; pageNo <= doc.numPages; pageNo++) {
      const page = await doc.getPage(pageNo);
      const content = await page.getTextContent();
      const rows = new Map<number, { x: number; s: string }[]>();
      for (const item of content.items) {
        if (!('str' in item) || !item.str.trim()) continue;
        const y = Math.round(item.transform[5]);
        if (!rows.has(y)) rows.set(y, []);
        rows.get(y)!.push({ x: item.transform[4], s: item.str });
      }
      for (const y of [...rows.keys()].sort((a, b) => b - a)) {
        const line = rows.get(y)!.sort((a, b) => a.x - b.x).map((cell) => cell.s).join(' ').replace(/\s+/g, ' ').trim();
        if (line) lines.push(line);
      }
    }
  } finally {
    await loadingTask.destroy();
  }
  return lines.join('\n');
}
